import { useState } from "react";
import Iconify from "@/components/ui/Iconify";
import { useTranslations } from "@/lib/static-intl";
import ReviewFormMedia from "./review-content-media";
import ReviewPostForm from "./review-content-form";

const PlaceReviewCreateModal = ({ placeId, isOpen, onClose, resetModal }) => {
  const t2 = useTranslations("places.place_review_create_modal");

  const [noteDetails, setNoteDetails] = useState({
    title: "",
    description: "",
    username: "",
    review: "",
    media: [],
    isPublic: true,
    isPinned: false,
    isTimelyRelease: true,
    status: "published",
    rating: 0,
    releaseTime: new Date(),
  });

  const toggleMediaUploader = () => {
    setNoteDetails((prev) => ({
      ...prev,
      media: [],
    }));
  };

  const closeModal = () => {
    onClose();
    setNoteDetails({
      title: "",
      description: "",
      username: "",
      review: "",
      media: [],
      rating: 0,
      status: "published",
      isPinned: false,
      isPublic: true,
      isTimelyRelease: true,
      releaseTime: null,
    });
  };
  return (
    <>
      {isOpen && (
        <div
          onClick={closeModal}
          className="fixed top-0 left-0 right-0 bottom-0 z-[96] h-screen w-screen flex items-center justify-center overflow-hidden bg-black/60 backdrop-blur"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-full h-full md:max-h-[90%] md:max-w-[75%] bg-white dark:bg-dark_bg_grey overflow-y-auto thin-scrollbar md:overflow-hidden md:rounded-xl flex flex-col"
          >
            <div className="w-full py-5 px-6 md:px-10 border-b dark:border-brown flex items-center justify-between bg-white dark:bg-dark_bg_grey">
              <span className="text-xl font-semibold">
                {t2("write_a_review")}
              </span>
              <button
                type="button"
                onClick={closeModal}
                className="rounded-full active:bg-black/10"
              >
                <Iconify
                  icon={"iconamoon:close-thin"}
                  className={"!w-8 !h-8"}
                />
              </button>
            </div>
            {noteDetails?.media?.length === 0 ? (
              <ReviewFormMedia
                noteDetails={noteDetails}
                setNoteDetails={setNoteDetails}
                toggleMediaUploader={toggleMediaUploader}
              />
            ) : (
              <ReviewPostForm
                noteDetails={noteDetails}
                setNoteDetails={setNoteDetails}
                placeId={placeId}
                resetModal={resetModal}
                onClose={onClose}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PlaceReviewCreateModal;
